import {lazy} from "react";

const widgets = {
    "share-price-header": lazy(() => import("./SharePriceHeader")),
    "rns-mini": lazy(() => import("./RNSMini"))
}

export default widgets;